import React from "react";

import classNames from "classnames/bind";

import styles from "./Flex.module.scss";

import type { PropsWithChildren } from "react";

import type { FlexItemProps } from "./types";

const cx = classNames.bind(styles);

export const Item = ({
  flex = 1,
  grow,
  shrink,
  basis,
  order,
  children,
}: PropsWithChildren<FlexItemProps>) => {
  return (
    <div
      className={cx("item")}
      style={{
        flex,
        ...(grow ? { "flex-grow": grow } : {}),
        ...(shrink ? { "flex-shrink": shrink } : {}),
        ...(basis ? { "flex-basis": basis } : {}),
        ...(order ? { order: order } : {}),
      }}
    >
      {children}
    </div>
  );
};
